import { render, staticRenderFns } from "./skip-link.vue?vue&type=template&id=4148d8c4&"
import script from "./skip-link.vue?vue&type=script&lang=js&"
export * from "./skip-link.vue?vue&type=script&lang=js&"
import style0 from "./skip-link.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports